module.exports = __webpack_public_path__ + "assets/img/wdzy.a2d53b85.png";